import { Component, Input, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DynamicRule } from '@pdqdev/pdq-shared/dist/entities/Rules';
import { Shop } from '@services/shops/shop.model';
import { Observable } from 'rxjs';
import { CustomUpsellFormTimerComponent } from './components/custom-upsell-form-timer/custom-upsell-form-timer.component';
import { TimerConfiguration } from '@pdqdev/pdq-shared/dist/interfaces';

enum CustomUpsellFormTab {
  SETTINGS = 'settings',
  TIMER = 'timer',
}

@Component({
  selector: 'custom-upsell-form',
  templateUrl: './custom-upsell-form.component.html',
  styleUrl: './custom-upsell-form.component.scss',
  standalone: false,
})
export class CustomUpsellFormComponent implements OnChanges {
  @Input() formGroup: UntypedFormGroup;
  @Input() restrictionsRules: DynamicRule[];
  @Input() entities: any[];
  @Input() shopCurrencySymbol: string;
  @Input() shop$: Observable<Shop>;
  @Input() shopService: any;
  @Input() loadedExtension: any;
  @Input() updateRequired: boolean;
  @Input() updateAppUrl: string;
  @Input() productImageBase64: string;
  @Input() customUpsellConfig: any[];
  @Input() upsellRateTypeConfig: any[];
  @Input() applyDiscountToOptions: any[];
  @Input() PlacementMode: any;
  @Input() camelCaseToTitleCase: (str: string) => string;
  @Input() formArrayFieldName: string;
  @Input() onApplyDiscountToChange: (event: any) => void;
  @Input() onProductImageChange: (base64Image: string) => void;
  @Input() clearImage: () => void;
  @Input() onUpdateAppPermissions: () => void;
  @Input() onTimerConfigurationChange: () => void;

  @ViewChild(CustomUpsellFormTimerComponent) timerComponent: CustomUpsellFormTimerComponent;

  tabs = [
    {
      label: 'Settings',
      value: CustomUpsellFormTab.SETTINGS,
    },
    {
      label: 'Timer',
      value: CustomUpsellFormTab.TIMER,
    },
  ];
  CustomUpsellFormTab = CustomUpsellFormTab;
  activeTab = CustomUpsellFormTab.SETTINGS;
  timerConfiguration: TimerConfiguration | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['loadedExtension']?.currentValue) {
      if (!this.timerConfiguration) {
        this.timerConfiguration = changes['loadedExtension'].currentValue?.template?.timerConfiguration || null;
      }
    }
  }

  handleApplyDiscountToChange(event: any) {
    if (this.onApplyDiscountToChange) {
      this.onApplyDiscountToChange(event);
    }
  }

  handleProductImageChange(base64Image: string) {
    if (this.onProductImageChange) {
      this.onProductImageChange(base64Image);
    }
  }

  handleClearImage() {
    if (this.clearImage) {
      this.clearImage();
    }
  }

  handleUpdateAppPermissions() {
    if (this.onUpdateAppPermissions) {
      this.onUpdateAppPermissions();
    }
  }

  handleTimerConfigurationChange() {
    if (this.timerComponent) {
      this.timerConfiguration = this.timerComponent.getTimerConfiguration();
    }
    if (this.onTimerConfigurationChange) {
      this.onTimerConfigurationChange();
    }
  }

  onTabChange(event: CustomUpsellFormTab) {
    if (this.activeTab === CustomUpsellFormTab.TIMER && this.timerComponent) {
      this.timerConfiguration = this.timerComponent.getTimerConfiguration();
    }
    this.activeTab = event;
  }

  getTimerConfiguration() {
    return this.timerComponent?.getTimerConfiguration() || this.timerConfiguration;
  }
}
